
const getPaginationRange = (current: number, total: number) => {
    const range: (number | string)[] = [];
    const minPagesToShow = 4; // Minimum number of pages to show before ellipsis
    
    // Always show first page
    range.push(1);
  
    // Calculate the range of pages to show
    let left = Math.max(2, current - 1);
    let right = Math.min(total - 1, current + 1);
  
    // If we're near the start, show more pages after current
    if (current <= 3) {
      right = Math.min(total - 1, minPagesToShow);
    }
    // If we're near the end, show more pages before current
    else if (current >= total - 2) {
      left = Math.max(2, total - minPagesToShow + 1);
    }
  
    // Add dots if there's a gap after first page
    if (left > 2) {
      range.push('...');
    }
  
    // Add pages around current page
    for (let i = left; i <= right; i++) {
      range.push(i);
    }
  
    // Add dots if there's a gap before last page
    if (right < total - 1) {
      range.push('...');
    }
  
    // Always show last page if there's more than one page
    if (total > 1) {
      range.push(total);
    }
  
    return range;
  };
  
  const CustomPagination = ({ currentPage, totalPages, onPageChange }: { currentPage: number, totalPages: number, onPageChange: (page: number) => void }) => {
    const range = getPaginationRange(currentPage, totalPages);
  
    return (
      <div className="flex items-center justify-center space-x-2 mt-3">
        {range.map((page, idx) => (
          page === '...' ? (
            <span key={idx} className="px-2 text-gray-700">.....</span>
          ) : (
            <button
              key={idx}
              className={`px-3 py-1 rounded-full border text-sm text-black ${
                page === currentPage ? 'font-bold border-black text-white bg-black' : 'border-gray-300'
              }`}
              onClick={() => onPageChange(Number(page))}
              disabled={page === currentPage}
            >
              {page}
            </button>
          )
        ))}
      </div>
    );
  };
  
  export default CustomPagination;